import { render } from "./SolarPanelCalculator.vue?vue&type=template&id=7b66b45e"
import script from "./SolarPanelCalculator.vue?vue&type=script&lang=js"
export * from "./SolarPanelCalculator.vue?vue&type=script&lang=js"

import "./SolarPanelCalculator.vue?vue&type=style&index=0&id=7b66b45e&lang=scss"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__